import { Swiper } from 'antd-mobile';
import { memo, useMemo } from 'react';

import { usePhotoSwipeLightbox } from '@/hooks/use-photo-swipe-lightbox';

import { PackageEnum } from '../../constants/enum';
import imgIntro1HD from '../../images/swiper-intro/swiper-intro-1-hd.png';
import imgIntro1 from '../../images/swiper-intro/swiper-intro-1.png';
import imgIntro10HD from '../../images/swiper-intro/swiper-intro-10-hd.png';
import imgIntro10 from '../../images/swiper-intro/swiper-intro-10.png';
import imgIntro11HD from '../../images/swiper-intro/swiper-intro-11-hd.png';
import imgIntro11 from '../../images/swiper-intro/swiper-intro-11.png';
import imgIntro12HD from '../../images/swiper-intro/swiper-intro-12-hd.png';
import imgIntro12 from '../../images/swiper-intro/swiper-intro-12.png';
import imgIntro2HD from '../../images/swiper-intro/swiper-intro-2-hd.png';
import imgIntro2 from '../../images/swiper-intro/swiper-intro-2.png';
import imgIntro3HD from '../../images/swiper-intro/swiper-intro-3-hd.png';
import imgIntro3 from '../../images/swiper-intro/swiper-intro-3.png';
import imgIntro4HD from '../../images/swiper-intro/swiper-intro-4-hd.png';
import imgIntro4 from '../../images/swiper-intro/swiper-intro-4.png';
import imgIntro5HD from '../../images/swiper-intro/swiper-intro-5-hd.png';
import imgIntro5 from '../../images/swiper-intro/swiper-intro-5.png';
import imgIntro6HD from '../../images/swiper-intro/swiper-intro-6-hd.png';
import imgIntro6 from '../../images/swiper-intro/swiper-intro-6.png';
import imgIntro7HD from '../../images/swiper-intro/swiper-intro-7-hd.png';
import imgIntro7 from '../../images/swiper-intro/swiper-intro-7.png';
import imgIntro8HD from '../../images/swiper-intro/swiper-intro-8-hd.png';
import imgIntro8 from '../../images/swiper-intro/swiper-intro-8.png';
import imgIntro9HD from '../../images/swiper-intro/swiper-intro-9-hd.png';
import imgIntro9 from '../../images/swiper-intro/swiper-intro-9.png';
import imgIntroAllHD from '../../images/swiper-intro/swiper-intro-all-hd.png';
import imgIntroAll from '../../images/swiper-intro/swiper-intro-all.png';
import imgIntroLiteHD from '../../images/swiper-intro/swiper-intro-lite-hd.png';
import imgIntroLite from '../../images/swiper-intro/swiper-intro-lite.png';
import imgIntroProHD from '../../images/swiper-intro/swiper-intro-pro-hd.png';
import imgIntroPro from '../../images/swiper-intro/swiper-intro-pro.png';
import imgIntroStandard2HD from '../../images/swiper-intro/swiper-intro-standard-2-hd.png';
import imgIntroStandard2 from '../../images/swiper-intro/swiper-intro-standard-2.png';

import './swiper-list.scss';

const id = 'swiper-list';

const imagesGroup = {
  [PackageEnum.LITE]: [
    {
      url: imgIntroAll,
      hdUrl: imgIntroAllHD,
    },
    {
      url: imgIntroLite,
      hdUrl: imgIntroLiteHD,
    },
    {
      url: imgIntro6,
      hdUrl: imgIntro6HD,
    },
    {
      url: imgIntro7,
      hdUrl: imgIntro7HD,
    },
    {
      url: imgIntro8,
      hdUrl: imgIntro8HD,
    },
    {
      url: imgIntro12,
      hdUrl: imgIntro12HD,
    },
  ],
  [PackageEnum.STANDARD]: [
    {
      url: imgIntroStandard2,
      hdUrl: imgIntroStandard2HD,
    },
    {
      url: imgIntro1,
      hdUrl: imgIntro1HD,
    },
    {
      url: imgIntro2,
      hdUrl: imgIntro2HD,
    },
    {
      url: imgIntro6,
      hdUrl: imgIntro6HD,
    },
    {
      url: imgIntro7,
      hdUrl: imgIntro7HD,
    },
    {
      url: imgIntro8,
      hdUrl: imgIntro8HD,
    },
    {
      url: imgIntro9,
      hdUrl: imgIntro9HD,
    },
    {
      url: imgIntro10,
      hdUrl: imgIntro10HD,
    },
    {
      url: imgIntro11,
      hdUrl: imgIntro11HD,
    },
    {
      url: imgIntro12,
      hdUrl: imgIntro12HD,
    },
  ],
  [PackageEnum.PRO]: [
    {
      url: imgIntroPro,
      hdUrl: imgIntroProHD,
    },
    {
      url: imgIntro1,
      hdUrl: imgIntro1HD,
    },
    {
      url: imgIntro2,
      hdUrl: imgIntro2HD,
    },
    {
      url: imgIntro3,
      hdUrl: imgIntro3HD,
    },
    {
      url: imgIntro4,
      hdUrl: imgIntro4HD,
    },
    {
      url: imgIntro5,
      hdUrl: imgIntro5HD,
    },
    {
      url: imgIntro6,
      hdUrl: imgIntro6HD,
    },
    {
      url: imgIntro7,
      hdUrl: imgIntro7HD,
    },
    {
      url: imgIntro8,
      hdUrl: imgIntro8HD,
    },
    {
      url: imgIntro9,
      hdUrl: imgIntro9HD,
    },
    {
      url: imgIntro10,
      hdUrl: imgIntro10HD,
    },
    {
      url: imgIntro11,
      hdUrl: imgIntro11HD,
    },
    {
      url: imgIntro12,
      hdUrl: imgIntro12HD,
    },
  ],
};

interface SwiperListProps {
  packageType: PackageEnum;
}

export const SwiperList = memo(({ packageType }: SwiperListProps) => {
  usePhotoSwipeLightbox(id);

  const images = useMemo(() => {
    return imagesGroup[packageType].map((image) => ({
      url: image.url,
      hdUrl: image.hdUrl,
      width: 2250,
      height: 2340,
    }));
  }, [packageType]);

  return (
    <div id={id} styleName="container">
      {/* 为了支持PhotoSwipe查看, 需要提前加载好所有图片dom, 不能使用虚拟滚动, Swiper */}
      <Swiper loop key={packageType}>
        {images.map((image, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Swiper.Item key={index}>
            <img
              className="previewable"
              styleName="img"
              draggable={false}
              src={image.url}
              alt=""
              loading="lazy"
              data-pswp-src={image.hdUrl}
              data-pswp-width={image.width}
              data-pswp-height={image.height}
            />
          </Swiper.Item>
        ))}
      </Swiper>
    </div>
  );
});
